export default __webpack_public_path__ + "static/media/rabbit.6c45dcec.png";